import { Controller } from '@hotwired/stimulus'
import LoginFormController from './login-form'

export default class LoginOtpFormController extends Controller<HTMLFormElement> {
  declare readonly loginFormOutlet: LoginFormController
  declare readonly submitTarget: HTMLButtonElement

  static outlets = ['login-form']
  static targets = ['otpAttempt', 'otpRemember', 'submit']

  // Lifecycle methods

  connect() {
    this.element.addEventListener('submit', this.#handleSubmit.bind(this))
  }

  disconnect() {
    this.element.removeEventListener('submit', this.#handleSubmit.bind(this))
    this.loginFormOutlet.reset()
  }

  otpAttemptTargetConnected(element: HTMLInputElement) {
    element.addEventListener('focus', this.#handleOtpAttemptInput.bind(this))
    element.addEventListener('input', this.#handleOtpAttemptInput.bind(this))
  }

  otpAttemptTargetDisconnected(element: HTMLInputElement) {
    element.removeEventListener('focus', this.#handleOtpAttemptInput.bind(this))
    element.removeEventListener('input', this.#handleOtpAttemptInput.bind(this))
  }

  otpRememberTargetConnected(element: HTMLInputElement) {
    element.checked = this.loginFormOutlet.initialRememberedValue
    element.addEventListener('input', this.#handleOtpRememberInput.bind(this))
  }

  otpRememberTargetDisconnected(element: HTMLInputElement) {
    element.removeEventListener('input', this.#handleOtpRememberInput.bind(this))
  }

  // Public methods

  focusOtpAttempt() {
    const visibleOtpAttempt = this.element.querySelector<HTMLInputElement>(
      '[data-login-otp-form-target=otpAttempt]:not(:disabled)',
    )
    visibleOtpAttempt?.focus()
  }

  // Private methods

  #handleOtpAttemptInput(event: InputEvent) {
    const { value } = event.target as HTMLInputElement
    this.loginFormOutlet.otpAttemptTarget.value = value
  }

  #handleOtpRememberInput(event: InputEvent) {
    const { checked } = event.target as HTMLInputElement
    this.loginFormOutlet.otpRememberTarget.checked = checked
  }

  #handleSubmit(event: SubmitEvent) {
    event.preventDefault()
    this.submitTarget.disabled = true
    this.submitTarget.innerText = this.submitTarget.dataset.submitsWith
    this.loginFormOutlet.submit()
  }
}
